import { FC } from 'react';
import { NavigationPageItem, DashboardSidebarPageItem } from '@toolpad/core';
import { Box } from '@mui/material';

import { RooftopHelpContent, InfoButton } from '@carcareers/components';

export interface RooftopPageItemProps {
  item: NavigationPageItem;
}

export const RooftopPageItem: FC<RooftopPageItemProps> = ({ item }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Box sx={{ flex: 1 }}>
        <DashboardSidebarPageItem item={item} />
      </Box>
      <Box sx={{ mr: 1 }}>
        <InfoButton tooltip="What are rooftops?" title="About Rooftops">
          <RooftopHelpContent />
        </InfoButton>
      </Box>
    </Box>
  );
};

export default RooftopPageItem;
